import React, { useState } from 'react';
import TipAmountButton from '../../atoms/TipAmountButton';
import stl from './TipAmountSelector.module.css'
const TipAmountSelector = ({ amounts = [1, 5, 10, 20], onSelectAmount }) => {
    const [selectedAmount, setSelectedAmount] = useState(null);

    const handleSelect = (amount) => {
        setSelectedAmount(amount);
        if (onSelectAmount) {
            onSelectAmount(amount / 100);
        }
    };

    return (
        <div className={stl.container}>
            {amounts.map((amount) => (
                <TipAmountButton
                    key={amount}
                    amount={amount / 100}
                    isSelected={selectedAmount === amount}
                    onClick={() => handleSelect(amount)}
                />
            ))}
        </div>
    );
};

export default TipAmountSelector;
